import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../../../layout";
import { Box } from "@material-ui/core";
import Table from "./table";
// import TableTwo from "./tableTwo";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '60vh',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    details: {
        width: '100%',
        margin: 'auto',
        borderRadius: 15,
        padding: "20px 27px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.down('sm')]: {
            width: "98%",
        }
    },
    item: {
        display: "flex",
        alignItems: "center",
        flexDirection: 'column',
        color: "black",
        textAlign:'center',
        overflow:'auto',
    },
    color: {
        color: theme.palette.light.type2
    },

}));

export default function Index() {

    const classes = useStyles()

    return (
        <Layout>
            <div className={classes['root']}>
                <div className={classes.details}>
                    <Box className={classes.item}>
                        <Table/>
                        {/* <TableTwo/> */}
                    </Box>
                </div>
            </div>
        </Layout>
    );
}

